const ClipboardText = ({ width = 20, height = 20, color = 'currentColor' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 18 18" fill="none">
      <path
        d="M6.10938 9.14453H11.1649"
        stroke={color}
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.10938 12.0332H9.27271"
        stroke={color}
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.55382 4.66672H10.4427C11.8872 4.66672 11.8872 3.9445 11.8872 3.22228C11.8872 1.77783 11.1649 1.77783 10.4427 1.77783H7.55382C6.8316 1.77783 6.10938 1.77783 6.10938 3.22228C6.10938 4.66672 6.8316 4.66672 7.55382 4.66672Z"
        stroke={color}
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.8889 3.23633C14.2939 3.36633 15.5 4.25466 15.5 7.55522V11.8886C15.5 14.7774 14.7778 16.2219 11.1667 16.2219H6.83333C3.22222 16.2219 2.5 14.7774 2.5 11.8886V7.55522C2.5 4.26188 3.70611 3.36633 6.11111 3.23633"
        stroke={color}
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default ClipboardText;
